import MessagingAndNotification from './MessagingAndNotification.component';

export default MessagingAndNotification;
